<template>
    <div style="padding-bottom: 70px;">
        <Query @query-click="handleQueryClick" ref="refsQuery" />
        <div v-loading="loading">
            <ObliqueTags :tags="tags" v-model="tagsActive" @tab-click="handleTabClick" />
            <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
                <jt-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini"
                    @sort-change="handlesortchange" @header-dragend="handleDragEnd" class="setSortHeight" header-cell-class-name="header-cell" border
                    @selection-change="handleSelectionChange"
                    stripe ref="refs_table">
                    <!-- 操作区随表头一起吸顶（workOrder_v5 §11 扩展·jt-table affix-prepend 插槽） -->
                    <template #affix-prepend>
                        <div class="operation-box op-box-in-affix">
                            <div class="operation-left">
                                <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="getCurAuth('work_order_label_edit')" plain
                                    v-matomo="{behaviorCategory: '素材工单', event: '点击',  name: '修改工单标签' }"
                                    @click="handleTagEdit(multipleSelection)"
                                >
                                    修改工单标签
                                </el-button>
                                <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="canDeliveryEdit" plain
                                    v-matomo="{behaviorCategory: '素材工单', event: '点击',  name: '修改落点时间' }"
                                    @click="handleDeliveryEdit(multipleSelection)"
                                >
                                    修改落点时间
                                </el-button>
                                <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="getCurAuth('download_material')" plain
                                    :disabled="!multipleSelection.length"
                                    :loading="downloadLoading"
                                    v-matomo="{behaviorCategory: '素材工单', event: '点击',  name: '下载素材' }"
                                    @click="handleDownloadMaterial"
                                >
                                    下载素材
                                </el-button>
                                <!-- workOrder_v4：素材分类标签归类规则速览（hover 弹层） -->
                                <el-popover placement="bottom-start" trigger="hover" width="340" popper-class="ml-help-pop">
                                    <div class="ml-help-body">
                                        <div class="ml-help-title">素材分类标签怎么来的</div>
                                        <div>按素材命名里的词自动归类，每条素材各级各记 1 次，按工单汇总。</div>
                                        <div v-for="d in mlDict" :key="d.level"><b>{{ mlLevelName[d.level] || d.level + '级' }}</b>：{{ d.names.join(' / ') }}</div>
                                                                        <div>命名用 <code>-</code> 分隔，如 <code>视创-标准-AI-前贴</code>；连写也能识别（<code>视创AI</code>）。</div>
                                        <div>一、二级没写 → 记「<span class="ml-help-red">未知</span>」并显示原文；三、四级可不写。</div>
                                        <div>同级写了多个 → 取最后一个，并标「<span class="ml-help-orange">多命中</span>」。</div>
                                    </div>
                                    <span slot="reference" class="ml-help-ref"><i class="el-icon-question"></i> 分类标签说明</span>
                                </el-popover>
                            </div>
                            <div class="operation-right">
                                <el-button icon="el-icon-s-operation" size="mini" @click="handleFieldTable">自定义列</el-button>
                                <el-button icon="el-icon-download" size="mini" :loading="exportLoading"
                                    @click="exportData">导出</el-button>
                            </div>
                        </div>
                    </template>
                     <el-table-column type="selection" width="55" >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column :prop="column.id" :label="column.display_name" :width="getLocalStorageWidth[column.id] || column.width"
                        :fixed="column.fixed !='' ? column.fixed : false" :sortable="getsortable(column.id)"
                        v-for="(column, index) in columns" :key="index">
                        <template slot="header" slot-scope="scope">
                            <el-tooltip effect="dark" placement="top" v-if="column.id=='company_name'||column.id=='bloc_name'">
                                <span>{{column.display_name}} <i class="el-icon-question"></i></span>
                                <div slot="content">
                                    <div v-if="column.id=='company_name'">
                                        <p>客户名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户。</p>
                                    </div>
                                    <div v-else>
                                        <p>集团名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户对应的集团。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户对应的集团。</p>
                                    </div>
                                </div>
                            </el-tooltip>
                            <span v-else-if="column.id=='special_content'" class="text-color-error">{{column.display_name}}</span>
                            <span v-else>{{column.display_name}}</span>
                        </template>
                        <template slot-scope="scope">
                            <div v-if="column.id=='urgent_level_text'">
                                <span v-if="scope.row['urgent_level'] == 2" style="color: #ff0000;"
                                    @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]}}</span>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]}}</span>
                            </div>
                            <div v-else-if="column.id=='pass_material_num'"
                                @dblclick="copyText(`${scope.row['pass_material_num']}/${scope.row['material_num']}`)">
                                <span style="color: #409EFF;padding-right: 5px;">{{scope.row['pass_material_num']}}</span>/
                                <span>{{scope.row['material_num']}}</span>
                            </div>
                            <div v-else-if="column.id == 'expected_end_time'"
                                @dblclick="copyText(`${scope.row['expected_end_time']}`)">
                                <span :style="{color: formatDateColor(scope.row['expected_end_time'])}">{{ scope.row['expected_end_time'] }}</span>
                            </div>
                            <div v-else-if="column.id=='material_status_num'">
                                <div v-if="scope.row['material_status_num'] == '-'">
                                    <span
                                        @dblclick="copyText(scope.row['material_status_num'])">{{scope.row['material_status_num']}}</span>
                                </div>
                                <div v-else
                                        @dblclick="copyText(`${scope.row['no_upload_material_num']}，${scope.row['no_audit_material_num']}，${scope.row['pass_material_num']})/${scope.row['material_num']}`)">
                                    <span style="color: #409EFF;cursor: pointer;" @click="handleInfo(scope.row, false)"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-已完成)', event: '点击',  name: '列表(查看)' }">({{scope.row['no_upload_material_num']}}</span>，
                                    <span style="color: #f56c6c;cursor: pointer;"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-已完成)', event: '点击',  name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, true, 'no_audit_list')">{{scope.row['no_audit_material_num']}}</span>，
                                    <span style="color: rgb(103, 194, 58);cursor: pointer;padding-right: 5px;"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-已完成)', event: '点击',  name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, true, 'pass_list')">{{scope.row['pass_material_num']}})</span>/
                                    <span style="">{{scope.row['material_num']}}</span>
                                </div>
                            </div>
                            <!-- 落点时间 + 任务侧改期原因（2026-09-14 workOrder_v3 需求二）：日期一行；原因灰字一行，超宽省略、hover 看全文 -->
                            <div v-else-if="column.id == 'delivery'" class="delivery-cell">
                                <div class="delivery-date">
                                    <span @dblclick="copyText(scope.row.delivery)">{{ scope.row.delivery || '-' }}</span>
                                    <i v-if="canDeliveryEdit" class="el-icon-edit-outline" @click="handleDeliveryEdit([scope.row])"></i>
                                </div>
                                <el-tooltip v-if="scope.row.delivery_reason" effect="dark" placement="top" :content="scope.row.delivery_reason">
                                    <div class="delivery-reason"><i class="el-icon-info"></i> {{ scope.row.delivery_reason }}</div>
                                </el-tooltip>
                            </div>
                             <material-label-cell v-else-if="column.id == 'material_label'" :v="scope.row.material_label" @copy="copyText"/>
                             <div v-else-if="column.id == 'work_order_label'" >
                                <div class="tab-box">
                                    <template v-for="item in scope.row['work_order_label']">
                                        <el-tag type="warning" :key="item.id" style="margin-right: 4px">{{item.name}}</el-tag>
                                    </template>
                                    <template v-if="!scope.row['work_order_label']?.length">-</template>
                                    <i v-if="getCurAuth('work_order_label_edit')"  @click="handleTagEdit([scope.row])" class="el-icon-edit-outline"></i>
                                </div>
                            </div>
                            <div v-else-if="column.id=='material_create_user'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText(item)">
                                        {{item}}</div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div v-else-if="column.id == 'deny_no_update'">
                                <span style="color: #ff0000;"
                                    @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]}}</span>
                            </div>
                            <div v-else-if="column.id=='controls'">
                                <div v-if="tagsActive == 1">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-制作中)', event: '点击',  name: '列表(查看)' }"
                                        :style="{color: '#409EFF'}" @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" :loading="scope.row.batchUploadLoading"
                                        v-if="getCurAuth('batch_upload_material')"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-制作中)', event: '点击',  name: '列表(批量上传)' }"
                                        :style="{color: '#409EFF'}"
                                        @click="handleBatchUpload(scope.row)">批量上传</el-button>
                                    <!-- 改落点时间（2026-09-14 需求二·操作列入口，与落点时间单元格里的铅笔并存·用户习惯在操作列找） -->
                                    <el-button type="text" size="mini" v-if="canDeliveryEdit"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-制作中)', event: '点击',  name: '列表(改落点时间)' }"
                                        :style="{color: '#409EFF'}" @click="handleDeliveryEdit([scope.row])">改落点时间</el-button>
                                </div>
                                <div v-else-if="tagsActive == 2">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-待结单)', event: '点击',  name: '列表(查看)' }"
                                        :style="{color: '#409EFF'}" @click="handleInfo(scope.row, false)">查看</el-button>
                                    <!-- 改落点时间（2026-09-14 需求二·操作列入口，与落点时间单元格里的铅笔并存·用户习惯在操作列找） -->
                                    <el-button type="text" size="mini" v-if="canDeliveryEdit"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-待结单)', event: '点击',  name: '列表(改落点时间)' }"
                                        :style="{color: '#409EFF'}" @click="handleDeliveryEdit([scope.row])">改落点时间</el-button>
                                </div>
                                <div v-else-if="tagsActive == 3">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        v-matomo="{behaviorCategory: '素材工单(任务管理-已完成)', event: '点击',  name: '列表(查看)' }"
                                        :style="{color: '#409EFF'}" @click="handleInfo(scope.row, false)">查看</el-button>
                                </div>
                            </div>
                            <div v-else-if="column.id=='company_name'||column.id=='bloc_name'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])" @dblclick="copyText((scope.row[column.id]||[]).join('；'))">{{(scope.row[column.id]||[]).join('；')||'-'}}</div>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else-if="column.id === 'bloc_star'">
                                <span class="stars">{{ '★'.repeat(scope.row.bloc_star||0) }}</span>
                                <span class="star-zero" v-if="!scope.row.bloc_star">未评级</span>
                            </div>
                            <div v-else-if="column.id=='detail_info'" @dblclick="copyText(item)">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <el-tooltip effect="dark" placement="top">
                                        <div @dblclick="copyTextArr(scope.row[column.id])">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                        <div slot="content">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText([item.info,item.urgent_level,item.urgent_level].join('-'))" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <span v-else>{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else
                                    @dblclick="copyText(scope.row[column.id])">
                                <HoverEllipsisTips :text="scope.row[column.id]" />
                            </div>
                        </template>
                    </el-table-column>
                </jt-table>
                <PageBar :isTop="false">
                    <div class="tar pt20 pr40 pb20 bg-white">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </PageBar>
            </div>
        </div>
    </div>
</template>

<script>
import Query from './query.vue'
import ObliqueTags from '../../../components/obliqueTags.vue'
import MaterialExtendItem from '../../../components/materialExtendItem.vue'
import API from "@/api/workOrder/material";
import {uniqBy,countBy, find} from "lodash";
import {fieldTableModal,uploadMaterialModal,repeatSizeModal,taskUploadingModal} from "@/views/workOrder/modal";
import {mapState, mapActions, mapMutations} from 'vuex';
import HoverEllipsisTips from '@/views/workOrder/components/hoverEllipsis.vue'
import MaterialLabelCell from '@/views/workOrder/material/components/materialLabelCell.vue'
import matomoFun from "@/utils/matomo.js";
import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
import PageBar from '@/components/PageBar'
import { tagEditModal, deliveryEditModal } from '../modalMaterial'
export default {
    name: 'TaskPage',
    components: {
        MaterialLabelCell,
        HoverEllipsisTips,
        Query,
        ObliqueTags,
        MaterialExtendItem,
        PageBar
    },
    props:{
        reload:{
            type: String,
            default: ''
        },
        query: {
            type: Object,
            default: function () {
                return {}
            }
        },
        pageFuncNames:Array,
        formatDateColor: Function,
    },
    data() {
        return {
            mlDict: [], // 素材分类标签字典按级分组（从库取·随库同步）
            mlLevelName: { 1: '一级', 2: '二级', 3: '三级', 4: '四级' },
            tableData: [],
            tags: [{
                value: '1',
                label: '制作中'
            }, {
                value: '2',
                label: '待结单'
            }, {
                value: '3',
                label: '已完成'
            }],
            tagsActive: '1',
            value: '1',
            queryData: {},
            currentPage: 1,
            pageSize: 30,
            pageNum: 1,
            total: 0,
            loading: false,
            exportLoading: false,
            downloadLoading: false,
            columns: [],
            modalList: [],
            selectList: [],
            // delivery = 落点时间（2026-08-31）：与其它时间列一样可排序。后端 getWorkOrderTaskList
            // 会把 order_fields='delivery' 换成完整子查询表达式，不依赖该列是否被勾选。
            sortList: ['order_id', 'material_num', 'deny_no_update', 'expected_end_time', 'ctime', 'rejected_time', 'finish_time', 'material_end_time', 'delivery'], //排序字段  前端指定
            curKey: 0,
            activated_once: 1,
            tableHeight: 'auto',
            getLocalStorageWidth: {},
            multipleSelection: [],
        }
    },
    computed:{
        // 修改落点时间（2026-09-14 workOrder_v3 需求二）：节点勾选即有；已完成 tab(3) 不可改
        canDeliveryEdit() { return this.getCurAuth('task_delivery_edit') && this.tagsActive != '3'; },
        ...mapState({
            uploadQueue: state => state.workOrder.workTaskList,
        }),
    },
    watch:{
        'query':{
            handler(n, o) {
                const {tagsActive} = n
                this.tagsActive = tagsActive ? tagsActive.toString() : '1'
            },
            deep: true,
            immediate: true
        },
        'tagsActive': {
            handler(val) {
                let name_list = this.tags.filter(item=>item.value == val)
                let cur_name = '制作中'
                if(name_list && name_list.length !== 0) {
                    cur_name = name_list[0].label
                }
                this.CHANGE_BREADCRUMB(['任务管理', cur_name])
            },
            immediate: true
        },
    },
    created() {
        this.getLocalStorageWidth = getStorage('localStorage', 'taskTableWidthMap') || {}
        this.loadMlDict()
    },
    mounted() {
        this.CLEAR_ROUTE_CACHE()
        // 监听窗口大小变化
        window.addEventListener('resize', this.calculateTableHeight)
    },
    activated() {
        let name_list = this.tags.filter(item=>item.value == this.tagsActive)
        let cur_name = '制作中'
        if(name_list && name_list.length !== 0) {
            cur_name = name_list[0].label
        }
        this.CHANGE_BREADCRUMB(['任务管理', cur_name])
        this.$nextTick(()=>{
            this.$refs.refs_table.doLayout()
            if(this.activated_once !== 1) {
                let res_params = {...this.queryData,order_status:this.tagsActive,fields: this.selectList, pn:this.currentPage,rn:this.pageSize}
                this.fetchGetList(res_params)
            }
        })
    },
    beforeDestroy() {
        // 移除窗口大小变化监听
        window.removeEventListener('resize', this.calculateTableHeight)
    },
    methods: {
        // 素材分类标签字典（进页面拉一次·说明弹层用）
        loadMlDict() {
            API.getMaterialNameLabels().then(res => { this.mlDict = (res && res.data) || [] }).catch(() => {})
        },
        ...mapActions('workOrder',[
            'ADD_ROUTE_LIST',
            'CLEAR_ROUTE_CACHE'
        ]),
        ...mapMutations('app', [
            'CHANGE_BREADCRUMB',
        ]),
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 修改落点时间（单行传 [row]，批量传 multipleSelection）
        handleDeliveryEdit(list) {
            if (!list.length) {
                return this.$message.warning('请选择工单后操作');
            }
            const { vm } = deliveryEditModal({
                props: { selectList: list },
                cbs: {
                    onSubmit: () => {
                        this.handleCurrentChange(this.currentPage)
                        vm.close()
                    }
                }
            })
        },
        handleTagEdit(list) {
            if(list.length == 0) {
                return this.$message.warning('请选择工单后操作');
            };
            const onSubmit = (data) => {
                this.handleCurrentChange(this.currentPage)
                vm.close()
            }
            const { vm } = tagEditModal({
                props: {
                    selectList: list,
                    type: 'order_task',
                },
                cbs: {
                   onSubmit
                }
            })
        },
        // 列表批量下载工单素材（异步打包，走离线下载中心）
        handleDownloadMaterial() {
            const order_ids = this.multipleSelection.map(item => item.order_id)
            if (order_ids.length === 0) {
                return this.$message.warning('请选择工单后操作');
            }
            this.downloadLoading = true
            API.batchDownloadOrderMaterial({ order_ids }).then(res => {
                // 文案由服务端拼（含「部分工单无素材已跳过（xxx）」），前端不写死
                this.$message.success(res.info)
            }, err => {
                if (err && err.info) this.$message.error(err.info)
            }).finally(() => {
                this.downloadLoading = false
            })
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        pushMatomo(name) {
            let cur_name = find(this.tags, item=>item.value == this.tagsActive)
            let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, '点击', name)
        },
        fetchGetCustomField(params) {
            this.loading = true
            API.getCustomField({field_type: 'work_order_task', sub_type: this.tagsActive}).then(res => {
                let result = res.data
                let user_field = result.user_field
                this.modalList = result.field ? result.field : []
                this.selectList = user_field
                let uni_fixed_data = []
                let uni_drag_data = []

                let reduce_list = this.modalList.reduce((prev, cur) => {
                    if (cur?.children.length > 0) {
                        prev.push(...cur.children);
                        return prev
                    }
                }, [])

                for(const item of user_field) {
                    reduce_list.forEach((el)=>{
                        if(el.checked) {
                            if (!!el['config']) {
                                let toObjectConfig = JSON.parse(el['config'])
                                if(item == el['id']) {
                                    if (toObjectConfig['fixed']) {
                                        uni_fixed_data.push({
                                            id: el['id'],
                                            width: 150,
                                            display_name: el["display_name"],
                                            fixed: toObjectConfig['fixed'],
                                        })
                                    } else {
                                        uni_drag_data.push({
                                            id: el['id'],
                                            width: 150,
                                            display_name: el["display_name"],
                                            fixed: null,
                                        })
                                    }
                                }
                            }else {
                                if(item == el['id']) {
                                    uni_drag_data.push({
                                        id: el['id'],
                                        width: 120,
                                        display_name: el["display_name"],
                                        fixed: null,
                                        disabled: null
                                    })
                                }
                            }
                        }
                    })
                }

                let fixedData = uniqBy(uni_fixed_data, 'id')
                let dragData = uniqBy(uni_drag_data, 'id')
                this.columns = [...fixedData, ...dragData].map(item => {
                    if (item.id == 'material_status_num') {
                        item['width'] = 250
                    }
                    return item
                })
                this.$nextTick(() => {
                    // 确保表格重新计算布局
                    this.$refs.refs_table.doLayout();
                });
                this.fetchGetList({...params, fields: this.selectList})
            }, err=>{
                this.loading = false
                this.$message.error(err.info)
            })
        },
        fetchSetCustomField(values) {
            // let res_filter = this.listMap.filter(item=>values.includes(item.name))
            API.editCustomField({
                field_type: 'work_order_task',
                fields: values,
                sub_type: this.tagsActive
            }).then(res => {
                this.$message.success('成功')
                let res_params = {...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize}
                this.fetchGetCustomField(res_params)
            }, err=>{
                this.$message.error(err.info)
            })
        },
        fetchGetList(params) {
            this.loading = true
            API.postOrderTaskGetList(params).then((res) => {
                if (!params.export) {
                    this.tableData = (res?.data?.list ? res.data.list : []).map(item=>{
                        item.batchUploadLoading = false;
                        return item;
                    });
                    this.total = res.data.totalCnt
                    this.tags = [{
                        value: '1',
                        label: '制作中',
                        num: res.data.in_production_num ? res.data.in_production_num : 0
                    }, {
                        value: '2',
                        label: '待结单',
                        num: res.data.no_finish_num ? res.data.no_finish_num : 0
                    }, {
                        value: '3',
                        label: '已完成',
                        num: res.data.in_finish_num ? res.data.in_finish_num : 0
                    }]
                    this.loading = false
                    this.$refs.refs_table.$forceUpdate()
                    this.calculateTableHeight()
                }else{
                    // 导出的情况
                    this.exportLoading = false
                    this.loading = false
                    this.$message.success(res.info)
                }
                this.curKey++
            }, err=>{
                this.loading = false
                this.exportLoading = false
                this.$message.error(err.info)
            })
        },
        // 排序
        handlesortchange({column, prop, order}) {
            // ascending 升   descending 降
            let order_type = order == 'ascending' ? 'asc' : 'desc'
            this.queryData['order_fields'] = prop
            this.queryData['order'] = order_type
            let res_params = {
                ...this.queryData,
                order_status: this.tagsActive,
                fields: this.selectList,
                pn: this.currentPage,
                rn: this.pageSize
            }
            this.loading = true
            this.fetchGetList(res_params)
        },
        // 排序显示
        getsortable(value) {
            if (this.sortList.includes(value)) {
                return 'custom'
            } else {
                return false
            }

        },
        // 折角矩形 标签点击
        handleTabClick(val) {
            this.$refs.refs_table.clearSort()
            this.columns = []
            this.tableData = []
            this.queryData['order_fields'] = ''
            this.queryData['order'] = ''
            let res_params = {...this.queryData, order_status: val, pn: this.currentPage, rn: this.pageSize}
            this.loading = true
            this.fetchGetCustomField(res_params)

            this.$router.replace({
                name:'work_order_material',
                query: {
                    topage: 'TaskPage',
                    tagsActive: val ? val.toString() : '1',
                },
                params:{
                    menuReload: 1
                }
            });
        },
        handleFieldTable() {
            this.pushMatomo('自定义列')
            const {vm} = fieldTableModal(
                {
                    props: {
                        customClass: 'custom-indicator-new apple-custom-indicator',
                        customList: this.modalList,
                        selectList: this.selectList
                    },
                    cbs: {
                        onSubmit: (data) => {
                            this.tableData = []
                            this.fetchSetCustomField(data)
                            vm.close()
                        },
                        onClose:() => {
                            vm.close()
                        }
                    }
                }
            )
        },
        // 查询结果
        handleQueryClick(params) {

            this.queryData = params.params
            if(params.status) {
                this.tagsActive = 1
                this.$refs.refs_table.clearSort()
                this.queryData['order_fields'] = ''
                this.queryData['order'] = ''
                let res_params = {...this.queryData,order_status:this.tagsActive, pn:1,rn:this.pageSize}
                this.fetchGetCustomField(res_params)
                return
            }

            let res_params = {...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize}
            this.fetchGetCustomField(res_params)
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            let res_params = {...this.queryData,order_status:this.tagsActive,fields: this.selectList, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            let res_params = {...this.queryData,order_status:this.tagsActive,fields: this.selectList, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 消息的点击跳转
        handleMsg() {
            this.tagsActive = 1
            let res_params = {...this.queryData,order_status:this.tagsActive, pn:1,rn:this.pageSize}
            this.fetchGetCustomField(res_params)
        },
        // 导出
        async exportData() {
            this.pushMatomo('导出')
            try {
                this.exportLoading = true
                let res_params = {...this.queryData,order_status:this.tagsActive,fields: this.selectList, pn:this.currentPage,rn:this.pageSize, export: '1' }
                await this.fetchGetList(res_params)
                // await this.getList()
            } catch (error) {}finally {
                this.exportLoading = false
            }
        },
        /**
         * show_type  展开详情的方式 true 全部展开  false
         * show_status  展开详情的状态
         * */
        handleInfo(rows, show_type, show_status) {
            if(!this.getCurAuth('work_order_info')) {
                this.$message.warning('您没有权限')
                return
            }
            // if(show_status) {
            //     this.$emit('changePage','TaskInfoPage',{order_id:rows.order_id, tagsActive:this.tagsActive, show_type:show_type, show_status:show_status});
            // }else{
            //     this.$emit('changePage','TaskInfoPage',{order_id:rows.order_id, tagsActive:this.tagsActive, show_type:show_type});
            // }

            // this.ADD_ROUTE_LIST(
            //     {
            //         formpage: 'TaskPage',
            //         topage:'TaskInfoPage',
            //         id:rows.order_id,
            //         tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
            //         show_type: show_type ? show_type : false,
            //         show_status: show_status ? show_status : '',
            //         date: new Date().getTime()
            //     }
            // )
            this.ADD_ROUTE_LIST(this.query)
            this.$router.push({
                name:'work_order_material',
                query: {
                    formpage: 'TaskPage',
                    topage:'TaskInfoPage',
                    id:rows.order_id,
                    tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
                    show_type: show_type ? show_type : false,
                    show_status: show_status ? show_status : ''
                },
                params:{
                    menuReload: 1
                }
            });
            this.activated_once++

        },
        // 批量上传
        handleBatchUpload(row) {
            console.log('handleBatchUpload',row);
            if(row.batchUploadLoading) return console.log('多次点击');
            row.batchUploadLoading = true;

            API.checkBeforeUpload({
                order_id:row.order_id,
            }).then(res=>{
                console.log('checkBeforeUpload',res);
                let resData = res.data||{};
                let denyList = (resData.deny_no_update_list||[]).map(item=>item.assign_id);
                let list = (resData.list||[]).filter(item=>{
                    return !denyList.includes(item.assign_id);
                });
                let errList = resData.err_list||[];
                let errMsg = resData.err_msg||[];

                if(errMsg.length>0){
                    row.batchUploadLoading = false;
                    let errMsgText = errMsg.map(item=>{
                        let isHasId = (item.ids||[]).length>0;
                        if(isHasId){
                            return '<p style="line-height: 20px;">'+item.info+'<br/>任务ID：'+(item.ids||[]).join('，')+'</p>';
                        }else{
                            return '<p style="line-height: 20px;">'+item.info+'</p>';
                        }
                    }).join('');
                    this.$message.error({
                        message:errMsgText,
                        dangerouslyUseHTMLString:true,
                    });
                }else if(errList.length>0){
                    const {vm} =taskUploadingModal({
                        props: {
                            list:errList,
                        },
                        cbs:{
                            onSubmit:()=>{
                                console.log('触发详情关闭,继续上传');
                                row.batchUploadLoading = false;
                                if(list.length>0){
                                    this.submitBatchUpload(row,list);
                                }else{
                                    this.$message.error('该任务暂无可上传素材数量');
                                }
                            },
                            onClose:()=>{
                                vm.close();
                                row.batchUploadLoading = false;
                            },
                        }
                    });
                }else if(list.length>0){
                    row.batchUploadLoading = false;
                    this.submitBatchUpload(row,list);
                }else{
                    row.batchUploadLoading = false;
                    this.$message.error('该任务暂无可上传素材数量');
                }
            },err=>{
                row.batchUploadLoading = false;
                console.log('checkBeforeUpload err',err);
                this.$message.error(err.info||'请求异常')
            });
        },
        submitBatchUpload(row,list){
            console.log('submitBatchUpload',666,row,list);
            this.batchUploadLoading = true;
            API.getWorkTaskDetailList({
                order_id:row.order_id,
            }).then(res=>{
                console.log('getWorkTaskDetailList',res.data,list,this.uploadQueue);
                row.batchUploadLoading = false;
                let rawTaskList = (res.data||[]).map(item=>{
                    item.order_id == row.order_id;
                    return item;
                }).filter(item=>{
                    // 过滤掉不在list里的数据
                    return list.map(inner=>inner.assign_id).includes(item.assign_id);
                }).filter(item=>{
                    // 过滤掉上传队列里的数据
                    return !this.uploadQueue.find(inner=>item.assign_id==inner.assign_id);
                }).filter(item=>item.allow_upload_num>0);

                if(rawTaskList.length<=0) return this.$message.error('该任务暂无可上传素材数量');

                let sizeCountMap = countBy(rawTaskList,(item)=>item.width+'*'+item.height);
                let repeatSize = [];        // 存在重复的尺寸
                let noRepeatSize = [];      // 不重复的尺寸
                for (let size in sizeCountMap){
                    if(sizeCountMap[size]>1){
                        repeatSize.push(size);
                    }else{
                        noRepeatSize.push(size);
                    }
                }

                if(repeatSize.length>0){
                    repeatSizeModal({
                        props: {
                            title: '温馨提示',
                            taskList:rawTaskList,
                            repeatList:repeatSize,
                        },
                        cbs:{
                            onSubmit:(sizeData)=>{
                                console.log('触发详情关闭',sizeData);
                                let taskList = noRepeatSize.map(item=>{
                                    return rawTaskList.find(inner=>inner.width+'*'+inner.height===item);
                                }).concat(repeatSize.map(item=>{
                                    return rawTaskList.find(inner=>inner.width+'*'+inner.height===item&&inner.assign_id==sizeData[item]);
                                }));
                                const {vm} = uploadMaterialModal({
                                    props: {
                                        title: '素材上传',
                                        taskList:taskList,
                                        orderInfo:{...row},
                                        isBatch:true,
                                    },
                                    cbs:{
                                        onSubmit:(data)=>{
                                            console.log('触发详情关闭',data);
                                            this.$store.commit('workOrder/ADD_WORK_TASK_ITEM', data);
                                        },
                                    },
                                    on:{
                                        close:()=>{
                                            vm.close()
                                            this.pushMatomo('列表(批量上传-取消)')
                                        }
                                    }
                                })
                            },
                        }
                    });
                }else{
                    const {vm} = uploadMaterialModal({
                        props: {
                            title: '素材上传',
                            taskList:rawTaskList,
                            orderInfo:{...row},
                            isBatch:true,
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                console.log('触发详情关闭',data);
                                this.$store.commit('workOrder/ADD_WORK_TASK_ITEM', data);
                            },
                        },
                        on:{
                            close:()=>{
                                vm.close()
                                this.pushMatomo('列表(批量上传-取消)')
                            }
                        }
                    })
                }
            },()=>{
                row.batchUploadLoading = false;
            })
        },
        // 复制文本
        copyText(text) {
            if (!text || text === '-') return
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },
        copyTextArr(arr) {
            if (!arr || arr.length == 0) return
            const text = arr.map(item => `${item.info}-${item.urgent_level}-${item.expected_end_time}`).join('；')
            this.copyText(text)
        },
        // 计算表格最大高度
        calculateTableHeight() {
            const height = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            let tableContainerHeight = 0
            this.$nextTick(() => {
                // 获取容器元素
                const container = this.$el.querySelector('.el-table__body')
                if (container) {
                    // 计算容器高度减去头部和底部区域
                    tableContainerHeight = container.offsetHeight
                } else {
                    tableContainerHeight = 0
                }
                if (tableContainerHeight >= height - 200) {
                    this.tableHeight = 'calc(100vh - 120px)'
                } else {
                    this.tableHeight = 'auto'
                }
            })
        },
        handleDragEnd(newWidth, oldWidth, column) {
            let getCurrentNameWidth = this.getLocalStorageWidth || {}
            //存储示例格式 {address: 707, date: 184, name: 246}
            let result = Object.assign(getCurrentNameWidth, {
                [column.property]: parseInt(newWidth),
            });
            setStorage('localStorage', 'taskTableWidthMap', Object.assign({},this.getLocalStorageWidth,result));
        },
    },
}
</script>
<style lang="scss" scoped>
.delivery-cell {
    line-height: 18px;
    .delivery-date .el-icon-edit-outline { margin-left: 4px; color: #409EFF; cursor: pointer; }
    .delivery-reason {
        font-size: 12px; color: #909399; max-width: 100%;
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        .el-icon-info { color: #E6A23C; }
    }
}
.ml-help-ref { margin-left: 10px; font-size: 12px; color: #909399; cursor: pointer; }
.ml-help-ref:hover { color: #409eff; }
@import "~@/styles/material_sd.scss";
</style>
<style>
.custom-indicator-new{
    min-width: 900px;
}
</style>
<style scoped lang="scss">
.tab-box {
    i {
        display: none;
        cursor: pointer;
        color: rgb(64, 158, 255);
    }
    &:hover {
        i {
            display: inline;
        }
    }
}
.stars { color: #f7ba2a; letter-spacing: 1px; }
.star-zero { color: #c0c4cc; }
/* §11 扩展：操作区进吸顶块后用块内间距 */
.operation-box.op-box-in-affix { margin-bottom: 6px; }
</style>
<style>
.ml-help-pop .ml-help-body { font-size: 12px; line-height: 20px; color: #606266; }
.ml-help-pop .ml-help-title { font-weight: 600; color: #303133; margin-bottom: 4px; }
.ml-help-pop code { background: #f4f4f5; padding: 0 4px; border-radius: 2px; }
.ml-help-pop .ml-help-red { color: #f56c6c; }
.ml-help-pop .ml-help-orange { color: #e6a23c; }
</style>
